import React from "react";
import { TextField } from "material-ui";

import PhoneInput from "react-phone-number-input/basic-input/index.commonjs.js";

/**
 * Display phone input fields in a user-friendly format
 * A thin wrapper around material-ui's <TextField/>.
 */
class PhoneField extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { onChange, ...props } = this.props;

    return (
      <TextField type="tel" {...props}>
        <PhoneInput
          value={props.value || ""}
          country="US"
          onChange={v => onChange({ target: { value: v } })}
        />
      </TextField>
    );
  }
}

export default PhoneField;



// WEBPACK FOOTER //
// ./src/app/components/partials/phone-field.jsx